// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1viK_","tab":"Tabs_tab__32SUx","tabActive":"Tabs_tabActive__1Xhjr"};